import { categories } from "@/mocks/categories";
import SectionHeader from "@/components/base/SectionHeader";

interface CategoriesProps {
  activeCategory: string;
  onPick: (key: string) => void;
}

const iconStyles: Record<string, string> = {
  gossip: "bg-primary-100 text-primary-600",
  celeb: "bg-accent-100 text-accent-600",
  bts: "bg-secondary-100 text-secondary-600",
  variety: "bg-accent-200 text-accent-700",
  behind: "bg-primary-100 text-primary-700",
};

export default function Categories({ activeCategory, onPick }: CategoriesProps) {
  return (
    <section id="categories" className="w-full bg-background-100/60 px-4 py-14 md:px-6 md:py-20">
      <div className="mx-auto flex w-full max-w-7xl flex-col gap-8">
        <SectionHeader
          eyebrow="视频分类"
          title="五大吃瓜板块，各取所需"
          subtitle="从娱乐八卦到幕后探班，不同内容分区清晰归类。点击任意分类，视频库会立即为你筛选对应内容。"
        />

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
          {categories.map((cat) => {
            const active = activeCategory === cat.key;
            return (
              <button
                key={cat.key}
                type="button"
                onClick={() => onPick(cat.key)}
                className={`group flex flex-col items-start gap-4 rounded-2xl border p-6 text-left transition-all duration-300 hover:-translate-y-1 ${
                  active
                    ? "border-primary-300 bg-primary-50"
                    : "border-background-200/70 bg-background-50 hover:border-primary-200"
                }`}
              >
                <span
                  className={`flex h-12 w-12 items-center justify-center rounded-xl text-xl ${iconStyles[cat.key]}`}
                >
                  <i className={cat.icon} />
                </span>
                <span className="flex flex-col gap-1">
                  <span className="text-base font-bold text-foreground-950">{cat.name}</span>
                  <span className="text-xs leading-relaxed text-foreground-500">{cat.desc}</span>
                </span>
                <span className="mt-auto flex w-full items-center justify-between border-t border-background-200/70 pt-3">
                  <span className="text-xs text-foreground-500">{cat.count} 条内容</span>
                  <span
                    className={`flex items-center gap-1 text-xs font-bold transition-colors ${
                      active ? "text-primary-600" : "text-primary-500 group-hover:text-primary-600"
                    }`}
                  >
                    {active ? "正在浏览" : "去看看"}
                    <i className="ri-arrow-right-line text-[13px]" />
                  </span>
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}